// extracted by mini-css-extract-plugin
export default {"tagline":"Blueprint_tagline__O+ANn"};